import React from "react";
import "./styles/modalConfirmAction.css";
import Modal from "./Modal";

import { FaCheckCircle } from "react-icons/fa";

export default function ModalConfirmAction({
  isOpen,
  title,
  onClose,
  descriptionAction,
  buttonConfirmAction,
  textButtonConfirmAction,
  buttonCancelAction,
  textButtonCancelAction,
}) {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      otherClassModalInterface="modal-interface-complement"
      otherClassModalContent="modal-content-complement"
    >
      <p>{descriptionAction}</p>
      <div className="container-bts-modal">
        <button onClick={buttonConfirmAction}>{textButtonConfirmAction}</button>
        <button onClick={buttonCancelAction}>{textButtonCancelAction}</button>
      </div>
    </Modal>
  );
}

export function ModalMessage({
  isOpen,
  title,
  onClose,
  descriptionAction,
  buttonConfirmAction,
}) {
  return (
    <Modal
      isOpen={isOpen}
      title={
        <>
          <i>
            <FaCheckCircle />
          </i>
          <span>{title}</span>
        </>
      }
      onClose={onClose}
      otherClassModalInterface="modal-interface-complement-message-sucess"
      otherClassModalContent="modal-content-complement-message-sucess"
    >
      <p>{descriptionAction}</p>
      <button onClick={buttonConfirmAction}>OK</button>
    </Modal>
  );
}
